<template>
  <div class="reviewDetail" style="position: relative;">
    <template v-if="isReviewIndex">
      <div @click="showQRCode" class="QRCode">
        <img src="@/assets/img/QRCode_icon.png" alt="">
        <p>扫码推送消息</p>
      </div>
      <ots-main-title></ots-main-title>
      <el-form
        :inline="true"
        ref="form"
        label-width="120px"
        class="select-con refer-from"
      >
        <el-form-item class="change-label-calss" label="考试批次：">
          <el-select v-model="requestForm.planId" collapse-tags>
            <el-option
              v-for="(item, key) in selectList.data"
              :key="key"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="timeFrame" v-if="requestForm.planId">
        <span>教师可评阅时间范围：</span><span>{{ timeFrame }}</span>
      </div>

      <div class="table">
        <div class="colnum" v-for="(item, index) in tableList" :key="index">
          <div class="course">
            <span class="dis-black">{{ item.courseName }}</span>
          </div>
          <div class="personNum">
            <span class="discript">已分配人数：</span>
            <span class="dis-black">{{ item.assNumber }}</span>
          </div>
          <div class="personNum">
            <span class="discript">已考人数：</span>
            <span class="dis-black">{{ item.examNum }}</span>
          </div>
          <div :class="{ personNum: true, isCanClick: item.aReviewNum > 0 }">
            <span class="discript">已评阅人数：</span>
            <span class="dis-blue">{{ item.aReviewNum }}</span>
          </div>
          <div class="personNum">
            <span class="discript">待评阅人数：</span>
            <span :class="item.waitReviewNum > 0 ? 'dis-red' : 'dis-black'">{{ item.waitReviewNum }}</span>
          </div>
        </div>
        
        <div class="mainCon">
          <ots-table-group
            :tableHeader="tableHeader"
            :requestForm="requestForm"
            :tableData="tableData"
            :pagination="pagination"
            @changeNum="changeSize"
            @changePage="changePage"
          ></ots-table-group>
        </div>

      </div>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>

    <ots-custom-dialog :dialog.sync="showQRCodeDialog" title="扫码推送消息" width="30%">
      <template v-slot:content>
        <div class="exportDialog" >
          <img src="@/assets/img/WxQRCode.jpeg" alt="" style="margin: 0 auto;display: block;">
          <p style="text-align: center;">扫码关注公众号，及时接收消息推送。</p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showQRCodeDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>

<script>
import {
  getPlanList,
  getReviewCount,
  getUrl,
  TeacherReviewAllList,
  judgeTimeRangeSet,
  getTeacherReviewTimeListSet
} from "@/http/modules/markPaper";
import {
  getSinglePlan,
  getSelectPlanFn,
} from "@/http/modules/examSet/examBatch";
export default {
  data() {
    return {
      showQRCodeDialog: false,
      timeFrame: '',
      selectList: {
        title: "考试批次",
        type: "select",
        isSearch: true,
        requestKey: "planId",
        label: "name",
        value: "id",
        data: [],
      },
      requestForm: {
        planId: "",
        page: 1,
        size: 10,
      },
      pagination: {
        total: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "考试活动",
          prop: "arrangementName",
        },
        {
          title: "试卷名称",
          prop: "paperName",
        },
        {
          title: "已分配人数",
          prop: "assNumber",
        },
        {
          title: "已考人数",
          prop: "examNum",
        },
        {
          title: "待评阅人数",
          prop: "waitReviewNum",
        },
        {
          title: "已评阅人数",
          prop: "areviewNum",
        },
        {
          title: "操作",
          type: "buttons",
          width: "100",
          btnList: [
            {
              title: "查看",
              click: this.checkBatch,
              disableFn: (val) => (val.row.areviewNum > 0 ? false : true),
            },
            {
              title: "评阅",
              click: this.review,
              disableFn: (val) =>
              (this.timeRangeSet === true) && (val.row.waitReviewNum > 0 &&
                this.scorePublish == 0 )
                  ? false
                  : true,
            },
          ],
        },
      ],
      stuListParams: {
        page: 1,
        size: 10,
      },
      tableList: [],
      tableData: [],
      scorePublish: "",
      pagination: {
        total: 0,
      },
      timeRangeSet: "",
    };
  },
  watch: {
    "requestForm.planId"(val) {

      this.stuListParams.page = 1

      this.search(val);
      this.ReviewAllList(val);
      this.judgeTimeRange();
    },
  },
  computed: {
    isReviewIndex() {
      return this.$route.name == "review";
    },
  },
  mounted() {
    this.initData();
  },
  methods: {
    showQRCode() {
      this.showQRCodeDialog = true;
    },
    changeSize(num) {
      this.stuListParams.size = num;
      this.ReviewAllList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.ReviewAllList();
    },
    initData() {
      getPlanList().then((res) => {
        if (res.code == 1) {
          if (res.data.length > 0) {
            this.selectList.data = res.data;
            this.requestForm.planId = res.data[0].id;
          } else {
            this.$message.warning(
              "您当前没有被分配可评阅的批次，请联系相关人员进行分配！"
            );
          }
        }
      });
    },
    judgeTimeRange() {
      judgeTimeRangeSet({planId:this.requestForm.planId}).then((res) => {
        if (res.code == true) {
          this.timeRangeSet = res.data;
        }
      });
    },


    async ReviewAllList() {
      this.requestForm.size = this.stuListParams.size;
      this.requestForm.page = this.stuListParams.page;
      const { data } = await TeacherReviewAllList(this.requestForm);
      this.tableData = data.records;
      this.pagination.total = data.total;

      let param = {...this.requestForm}
      const { data: timeList } = await getTeacherReviewTimeListSet(param);
      const { teacherReviewBeginTime, teacherReviewEndTime } = timeList.records[0];
      this.timeFrame = `${teacherReviewBeginTime} ~ ${teacherReviewEndTime}`;

    },
    search(val) {
      let params = { ...this.requestForm };
      getReviewCount(params)
        .then((res) => {
          if (res.code == 1) {
            this.tableList = res.data;
          }
          return getSinglePlan({ planId: val });
        })
        .then((res) => {
          if (res.code == 1) {
            this.scorePublish = res.data.scorePublish;
          }
        });
    },
    checkBatch(row) {
      let planName;
      this.selectList.data.map((e) => {
        if (this.requestForm.planId == e.id) {
          planName = e.name;
        }
      });
      let query = {
        planId: this.requestForm.planId,
        planName,
        courseName: row.courseName,
        courseId: row.courseId,
        arrangementId: row.arrangementId,
      };
      this.$router.push({
        path: "review/reviewDetail",
        query,
      });
    },
    review(row) {
      let params = {
        arrangementId: row.arrangementId,
      };
      getUrl(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.table {
  margin-top: 16px;
  .colnum {
    padding: 0 32px;
    box-sizing: border-box;
    height: 72px;
    border-radius: 8px;
    background-color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .table-btn {
      width: 288px;
      display: flex;
      justify-content: right;
      /deep/ .el-button {
        width: 80px;
        height: 32px;
      }
    }
    // .isCanClick {
    //   cursor: pointer;
    // }
    .personNum {
      width: 288px;
      .discript {
        color: #9299a6;
      }
      .dis-black {
        color: #2d2f33;
        font-weight: 500;
      }
      .dis-blue {
        color: #006aff;
        font-weight: 500;
      }
      .dis-red {
        color: #fe5958;
        font-weight: 500;
      }
    }
    .course {
      width: 288px;
      .dis-black {
        font-weight: 500;
        color: #2d2f33;
        font-size: 16px;
      }
    }
  }
}

.timeFrame {
  height: 48px;
  background: #FFF;
  border-radius: 8px;
  margin-top: 16px;
  padding-left: 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  span:first-child {
    color: #626673;
  }
  span:last-child {
    color: #fe5958;
    font-weight: 700;
    display: inline-block;
    transition: 3s all ease-out;
  }
}


.query-btn {
  color: @c-006;
  border: 1px solid @c-006;
}
.select-con {
  background: #fff;
  position: relative;
  border-radius: 8px;
}
.refer-from {
  padding: 20px 24px 0px 24px;
  .el-form-item {
    margin-bottom: 20px;
  }
  /deep/ .el-form-item__label {
    padding-right: 4px !important;
  }
}
.change-label-calss /deep/ .el-form-item__label {
  color: #626673;
  text-align: right;
  display: inline-block;
}
.change-label-calss /deep/ .el-date-range-picker__time-header {
  display: none !important;
}
.change-label-calss /deep/ {
  margin-right: 40px !important;
  margin-bottom: 10px;
}
/deep/ .change-label-calss,
/deep/ .el-form-item__label {
  height: 36px;
  line-height: 36px !important;
}
/* 缴费日期最左侧图标位置 */
/deep/ .el-input__icon.el-range__icon.el-icon-date,
/deep/ .el-input__icon.el-range__icon.el-icon-time {
  box-sizing: border-box;
  margin-right: 8px;
  display: flex;
  justify-content: row;
  align-items: center;
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
.QRCode {
  cursor: pointer;
  width: 120px; 
  height: 36px; 
  color: #2e2e2e; 
  text-align: right; 
  position: absolute; 
  right: 0px; 
  top: 0px;
  transform: translate(-50%); 
  display: flex; 
  align-items: center;
  img {
    width: 16px; 
    height: 16px; 
    margin-right: 8px;
  }
}
</style>
